import { api } from "../api";
import axios from "axios";

function normalizeInteger(value) {
    if (value === undefined || value === null || value === "") {
        return null;
    }

    if (typeof value === "number") {
        return Number.isInteger(value) ? value : value;
    }

    const normalized = String(value).trim().replace(/\s+/g, "");

    return /^\d+$/.test(normalized) ? Number(normalized) : value;
}

function normalizeDecimal(value) {
    if (value === undefined || value === null || value === "") {
        return null;
    }

    if (typeof value === "number") {
        return value;
    }

    const normalized = String(value)
        .trim()
        .replace(/kg$/i, "")
        .replace(/\s+/g, "")
        .replace(",", ".");

    return /^\d+(\.\d+)?$/.test(normalized) ? Number(normalized) : value;
}

function normalizeAnimalPayload(payload) {
    return {
        numero: normalizeInteger(payload.numero),
        nom: payload.nom,
        date_naissance: payload.date_naissance || null,
        poids: normalizeDecimal(payload.poids),
        genre: payload.genre,
        phase_id: normalizeInteger(payload.phase_id),
        race_id: normalizeInteger(payload.race_id),
        user_id: normalizeInteger(payload.user_id),
        mother_id: normalizeInteger(payload.mother_id),
        ferme_id: normalizeInteger(payload.ferme_id),
    };
}


export const getAnimals = async () => {
    const token = localStorage.getItem('token');
    
    if (!token) {
        console.error('No token found!');
        throw new Error('Not authenticated');
    }
    const res = await axios.get(api+'animaux/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalsE = async () => {
    const res = await axios.get(api+'animals/',
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data',
            Accept: "application/json",
        }});
    return res.data;
}

export const getAnimalById = async (animalId) => {
    const res = await axios.get(api+'animaux/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalByIdE = async (animalId) => {
    const res = await axios.get(api+'animals/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}
export const getAnimalsByMotherId = async (animalId) => {
    const res = await axios.get(api+'animaux/mother/'+animalId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}



export const getAnimalsByUser = async (userId) => {
    const res = await axios.get(api+'animaux/user/'+userId,
        {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
        }});
    return res.data;
}

export const addAnimal= async({numero,nom,date_naissance,poids,genre,phase_id,race_id,user_id,mother_id,ferme_id}) => {
    const res = await axios.post(api+'animaux', normalizeAnimalPayload({
        numero: numero,
        nom: nom,
        date_naissance: date_naissance,
        poids: poids,
        genre: genre,
        phase_id: phase_id,
        race_id: race_id,
        user_id: user_id,
        mother_id: mother_id,
        ferme_id :ferme_id
    }),
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
    });
    return res.data;
}
export const addAnimalE= async({numero,nom,date_naissance,poids,genre,phase_id,race_id,user_id,mother_id,ferme_id}) => {
    const res = await axios.post(api+'animals', normalizeAnimalPayload({
        numero: numero,
        nom: nom,
        date_naissance: date_naissance,
        poids: poids,
        genre: genre,
        phase_id: phase_id,
        race_id: race_id,
        user_id: user_id,
        mother_id: mother_id,
        ferme_id : ferme_id
    }),
    {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",}
    });
    return res.data;
}

export const updateAnimal = async (animalId, data) => {
    const res = await axios.put(api + 'animaux/' + animalId, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });

    return res.data;
};

export const updateAnimalE = async (animalId, data) => {
    const res = await axios.put(api + 'animals/' + animalId, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            Accept: "application/json",
        }
    });

    return res.data;
};

export const deleteAnimal = async (animalId) => {
    await axios.delete(api+'animaux/'+animalId, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
}});
}

export const forceDeleteAnimal = async (animalId) => {
    await axios.delete(api+'animaux/force/'+animalId, {headers: {
            Authorization: 'Bearer '+localStorage.getItem('token'),
            Accept: "application/json",
}});
}
